export const FEATURE_NAME = '@vshosting/cdn/features/domain-existence-check-dialog';
